import React from 'react';
import './DeclineConfirmModal.css';

const DeclineConfirmModal = ({ onClose, onConfirm }) => {
  return (
    <div className="decline-confirm-modal-overlay" onClick={onClose}>
      <div className="decline-confirm-modal-content" onClick={e => e.stopPropagation()}>
        <button className="decline-confirm-modal-close" onClick={onClose}>×</button>
        
        <h2>Confirm decline channel(s)</h2>
        
        <p>When declining a channel, the channel artwork will be hidden on your devices and it will no longer be available to be set/played within your locations.</p>
        
        <div className="decline-confirm-modal-checkbox">
          <input type="checkbox" id="dontShow" />
          <label htmlFor="dontShow">Don't show this message again.</label>
        </div>

        <button className="decline-confirm-modal-button" onClick={onConfirm}>
          Confirm
        </button>
      </div>
    </div>
  );
};

export default DeclineConfirmModal; 